import { Input } from 'component/Input/Input'
import { observer } from 'mobx-react-lite'
import { i18n } from 'i18n'
import css from './SearchInput.module.scss'
import { Space } from 'component/Space'
import { ui } from 'store/home/ui/HomeUiStore'
import { Button } from 'component/Button'

interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  onCancel?: () => void
  placeholder?: string
}

export const SearchInput = observer(
  ({
    value,
    onChange,
    onCancel,
    placeholder = i18n('Search'),
  }: SearchInputProps) => {
    const { mobile } = ui.window

    return (
      <Space gap={8} className={css.searchContainer}>
        <Input value={value} onChange={onChange} placeholder={placeholder} />
        {mobile && <Button action={onCancel}>{i18n('combo.Cancel')}</Button>}
      </Space>
    )
  }
)
